
export const enum IdentifierTypeEnum {
    Unknown = 0,
    UPC,
    ISRC,
};

export function parseIdentifier(identifier: string) {
    const upcRegex = /^\d{11,14}$/;
    const isrcRegex = /^.{5}\d{7}$/;

    if (identifier.match(upcRegex)) {
        return IdentifierTypeEnum.UPC;
    }

    if (identifier.match(isrcRegex)) {
        return IdentifierTypeEnum.ISRC;
    }
    return IdentifierTypeEnum.Unknown;
}
